import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api, { API_BASE } from "@/lib/api";
import { STATE_STYLE, STATE_ORDER } from "@/components/StateBadge";
import { Filter, Printer, ExternalLink, Eye, X, Camera, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function ClientePedidos() {
  const [orders, setOrders] = useState([]);
  const [state, setState] = useState("");
  const [detail, setDetail] = useState(null);
  const [zoomPhoto, setZoomPhoto] = useState(false);

  const load = () => {
    const q = state ? `?state=${state}` : "";
    api.get(`/orders${q}`).then((r) => setOrders(r.data));
  };
  useEffect(() => { load(); }, [state]);

  const openDetail = (o) => {
    // Recargar el detalle para tener signed URL fresca de la foto
    api.get(`/orders/${o.id}`).then((r) => setDetail(r.data));
  };

  const printLabel = (oid) => {
    const token = localStorage.getItem("voycargo_token");
    fetch(`${API_BASE}/orders/${oid}/label.pdf`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => window.open(URL.createObjectURL(b), "_blank"));
  };

  const photoUrl = detail?.delivery_photo?.url;
  const lastNoDeliveryEntry = (o) =>
    (o.history || []).slice().reverse().find((e) => e.state === "no_entregado");

  return (
    <Layout>
      <div className="mb-8">
        <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-2">/ Mis envíos</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Mis pedidos</h1>
      </div>

      <div className="flex items-center gap-2 mb-6 flex-wrap">
        <div className="flex items-center gap-2 text-zinc-500 text-xs font-mono-tech uppercase tracking-widest"><Filter className="w-3.5 h-3.5" /> Filtro:</div>
        <button onClick={() => setState("")} className={`px-3 py-1.5 border text-xs font-mono-tech uppercase tracking-widest ${state === "" ? "border-yellow-300 text-yellow-300 bg-yellow-300/10" : "border-white/10 text-zinc-400"}`}>Todos</button>
        {STATE_ORDER.concat(["no_entregado"]).map((s) => (
          <button key={s} onClick={() => setState(s)} className={`px-3 py-1.5 border text-xs font-mono-tech uppercase tracking-widest ${state === s ? "border-yellow-300 text-yellow-300 bg-yellow-300/10" : "border-white/10 text-zinc-400"}`}>
            {STATE_STYLE[s]?.label}
          </button>
        ))}
      </div>

      <div className="border border-white/10 overflow-x-auto">
        <table className="w-full min-w-[800px]">
          <thead className="bg-zinc-900">
            <tr className="text-left text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500">
              <th className="px-4 py-3">Tracking</th>
              <th className="px-4 py-3">Destinatario</th>
              <th className="px-4 py-3">Dirección</th>
              <th className="px-4 py-3">Estado</th>
              <th className="px-4 py-3">Creado</th>
              <th className="px-4 py-3 text-right">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {orders.map((o) => (
              <tr key={o.id} className="hover:bg-zinc-900/60">
                <td className="px-4 py-3 font-mono-tech text-sm">{o.tracking_number}</td>
                <td className="px-4 py-3 text-sm">{o.destinatario?.nombre}</td>
                <td className="px-4 py-3 text-xs text-zinc-400 max-w-xs truncate">{o.destinatario?.direccion}, {o.destinatario?.comuna}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 border text-[10px] font-mono-tech uppercase tracking-wider ${STATE_STYLE[o.state]?.color}`}>
                    <span className="w-1 h-1 rounded-full bg-current" />
                    {STATE_STYLE[o.state]?.label}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono-tech text-xs text-zinc-400">{new Date(o.created_at).toLocaleDateString("es-CL")}</td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center gap-2 justify-end">
                    <button onClick={() => openDetail(o)} className="w-8 h-8 border border-white/10 hover:border-yellow-300/40 hover:text-yellow-300 inline-flex items-center justify-center" title="Ver detalle y evidencia" data-testid={`detail-${o.id}`}>
                      <Eye className="w-3.5 h-3.5" />
                    </button>
                    <button onClick={() => printLabel(o.id)} className="w-8 h-8 border border-white/10 hover:border-yellow-300/40 hover:text-yellow-300 inline-flex items-center justify-center" title="Etiqueta" data-testid={`print-${o.id}`}>
                      <Printer className="w-3.5 h-3.5" />
                    </button>
                    <Link to={`/rastreo/${o.tracking_number}`} target="_blank" className="w-8 h-8 border border-white/10 hover:border-yellow-300/40 hover:text-yellow-300 inline-flex items-center justify-center" title="Rastreo público">
                      <ExternalLink className="w-3.5 h-3.5" />
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-10 text-center text-zinc-500 font-mono-tech text-sm">Sin pedidos</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Detail modal */}
      {detail && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div className="bg-zinc-950 border border-white/10 max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest">/ Pedido</div>
                <div className="font-display font-black text-2xl tracking-tighter mt-1">{detail.tracking_number}</div>
              </div>
              <button onClick={() => setDetail(null)} className="text-zinc-400" data-testid="close-detail"><X className="w-5 h-5" /></button>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm mb-6">
              <div className="col-span-2">
                <div className="text-xs text-zinc-500 font-mono-tech uppercase tracking-widest mb-1">Destinatario</div>
                <div className="font-bold">{detail.destinatario?.nombre}</div>
                <div className="text-zinc-400 text-xs flex items-center gap-1 mt-0.5">
                  <MapPin className="w-3 h-3" />
                  {detail.destinatario?.direccion} · {detail.destinatario?.comuna}
                </div>
              </div>
              <div>
                <div className="text-xs text-zinc-500 font-mono-tech uppercase tracking-widest mb-1">Estado</div>
                <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 border text-[10px] font-mono-tech uppercase tracking-wider ${STATE_STYLE[detail.state]?.color}`}>
                  <span className="w-1 h-1 rounded-full bg-current" />
                  {STATE_STYLE[detail.state]?.label}
                </span>
              </div>
              <div>
                <div className="text-xs text-zinc-500 font-mono-tech uppercase tracking-widest mb-1">Repartidor</div>
                <div>{detail.repartidor_name || "-"}</div>
              </div>
            </div>

            {/* NO ENTREGA highlight */}
            {detail.state === "no_entregado" && (() => {
              const nd = lastNoDeliveryEntry(detail);
              if (!nd) return null;
              return (
                <div className="mb-6 border border-red-500/30 bg-red-500/5 p-4">
                  <div className="font-mono-tech text-xs text-red-400 uppercase tracking-widest mb-2">/ No pudimos entregar</div>
                  <div className="font-display font-bold text-lg">{nd.reason || "-"}</div>
                  {nd.comentario && (
                    <div className="mt-3 text-sm bg-zinc-900 border-l-2 border-red-500/60 pl-3 py-2 italic">&ldquo;{nd.comentario}&rdquo;</div>
                  )}
                </div>
              );
            })()}

            {/* DELIVERY PHOTO */}
            {detail.state === "entregado" && photoUrl && (
              <div className="mb-6" data-testid="delivery-photo-block">
                <div className="font-mono-tech text-xs text-emerald-300 uppercase tracking-widest mb-2 flex items-center gap-2">
                  <Camera className="w-3.5 h-3.5" /> / Foto de evidencia
                </div>
                <button onClick={() => setZoomPhoto(true)} className="w-full border border-emerald-500/30 hover:border-emerald-400 bg-black overflow-hidden">
                  <img src={photoUrl} alt="Evidencia de entrega" className="w-full max-h-96 object-contain" data-testid="delivery-photo-img" />
                </button>
                <div className="text-[10px] text-zinc-500 font-mono-tech mt-2">Click para ampliar · URL válida 7 días</div>
              </div>
            )}
            {detail.state === "entregado" && !photoUrl && (
              <div className="mb-6 border border-white/10 border-dashed p-4 text-xs text-zinc-500 font-mono-tech text-center">
                Sin foto de evidencia registrada
              </div>
            )}

            {/* HISTORY */}
            <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-3">/ Historial</div>
            <ol className="space-y-2">
              {(detail.history || []).slice().reverse().map((h, i) => (
                <li key={i} className="border-l-2 border-white/10 pl-4 py-1">
                  <div className="text-xs font-mono-tech uppercase tracking-widest text-yellow-300">{h.state_label || h.state}</div>
                  <div className="text-[11px] text-zinc-500">{h.timestamp?.slice(0, 19).replace("T", " ")} · {h.user_name || "-"} ({h.user_role})</div>
                  {h.reason && <div className="text-xs text-red-400/90 mt-0.5">Motivo: {h.reason}</div>}
                  {h.comentario && <div className="text-xs text-zinc-400 mt-0.5 italic">&ldquo;{h.comentario}&rdquo;</div>}
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}

      {/* Zoom photo lightbox */}
      {zoomPhoto && photoUrl && (
        <div className="fixed inset-0 bg-black/95 z-[60] flex items-center justify-center p-4" onClick={() => setZoomPhoto(false)}>
          <img src={photoUrl} alt="Evidencia zoom" className="max-w-full max-h-full object-contain" data-testid="delivery-photo-zoom" />
          <button onClick={() => setZoomPhoto(false)} className="absolute top-6 right-6 w-10 h-10 border border-white/30 text-white hover:border-yellow-300 hover:text-yellow-300 inline-flex items-center justify-center">
            <X className="w-5 h-5" />
          </button>
        </div>
      )}
    </Layout>
  );
}
